module.exports = __webpack_public_path__ + "static/media/form-bg.a9403250.png";